<template lang="pug">
    items-list(
    class="nav-container",
    :class="{ 'is-small': small }",
    :items="items",
    :level="1",
    :max-level="maxLevel",
    :small="small",
    :compact="true"
    )

</template>

<script>
    import ItemsList from './private/List.vue'

    export default {
        components: {
            ItemsList
        },
        data() {
            return {
                startHeight: 'auto'
            }
        },
        props: {
            items: Array,
            maxLevel: {
                type: Number,
                default: 2
            },
            small: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            styles() {
                return typeof window === 'undefined' ? {} : {
                    height: this.startHeight - (this.small ? 1 : 0) + 'px'
                };
            }
        },
        mounted() {
            this.startHeight = this.$el.offsetHeight;
        }
    }
</script>

<style lang="stylus" scoped>
    .nav-container
        position: relative
        z-index: 10000

    &::after
        content: ""
        clear: both
</style>


// WEBPACK FOOTER //
// Compact.vue?4fcf22e4